<template>
  <div
    class="tw-rounded-md tw-border tw-border-solid tw-border-[#EFF0F1] tex tw-bg-[#FFF]"
  >
    <div class="tw-flex tw-w-full tw-h-16 tw-items-center tw-px-[25px]">
      <span class="tw-text-[#211F58] tw-text-[15px] tw-font-semibold">
        {{ getComponentUiText("app-scan-scanning-types-title-1") }}
      </span>
    </div>
    <ScanningTypesCollapseItem
      v-for="item in scanningData"
      :key="item.scanDisplayTypeId"
      :title="item.scanDisplayType"
      :scan-items="getScanItem(item.scanItems)"
      :class-name="hoverBgColor"
    >
      <ScanningTypeResults
        :is-loading="isLoading"
        :data="item.scanItems"
        :type-id="item.scanDisplayTypeId"
        :scan-target-type="scanTargetType"
        :root-id="rootId"
      />
    </ScanningTypesCollapseItem>
  </div>
</template>

<script setup lang="ts">
import ScanningTypesCollapseItem from "@/components/scanning/scanningTypes/scanningTypesCollapseItem.vue";
import ScanningTypeResults from "@/components/scanning/scanningTypes/scanningTypeResults.vue";
import { getComponentUiText } from "@/utils/utilities";
import { computed, onMounted, ref, watch } from "vue";
import store from "@/store";
import { SCAN_ITEM_STATUS_ID, TYPE_SCHEDULE } from "@/utils/constants";

const props = defineProps<{
  isExpand?: boolean;
  runId: string;
  scanTargetType: keyof typeof TYPE_SCHEDULE;
  rootId: string;
  hoverBgColor?: string;
}>();

const isLoading = ref(true);

const scanningData = computed<Record<string, any>[]>(() => {
  const scanReportRun = store.getters["Scanning/getScanReportRun"];
  return scanReportRun[props.scanTargetType][props.runId]?.data || [];
});

const callData = async () => {
  if (props.isExpand && !scanningData.value?.length) {
    isLoading.value = true;
    await store.dispatch("Scanning/fetchScanReportRun", {
      runId: props.runId,
      scanTargetType: props.scanTargetType,
    });
  }
  isLoading.value = false;
};

onMounted(async () => {
  await callData();
});

watch(
  () => [props.isExpand, props.runId],
  async () => {
    await callData();
  },
);

const getScanItem = (scanItems) => {
  const severity = {
    critical: 0,
    high: 0,
    med: 0,
    low: 0,
  };

  if (scanItems?.length > 0) {
    scanItems.forEach((item) => {
      if (
        item.scanItemStatusId !== SCAN_ITEM_STATUS_ID.OK &&
        item.scanItemStatusId !== SCAN_ITEM_STATUS_ID.NOT_AVAILABLE &&
        item.scanItemStatusId !== SCAN_ITEM_STATUS_ID.NOT_APPLICABLE
      ) {
        severity[item.scanItemSeverityId] += 1;
      }
    });
  }
  return {
    critical: severity.critical ? severity.critical : null,
    high: severity.high ? severity.high : null,
    medium: severity.med ? severity.med : null,
    low: severity.low ? severity.low : null,
  };
};
</script>

<style scoped lang="scss">
.text {
  font-family: Poppins, sans-serif;
}
</style>
